import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { title: "Bejövő számlák" }, {
    text: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        modelValue: $setup.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
        label: "Keresés",
        "prepend-inner-icon": "mdi-magnify",
        variant: "outlined",
        "hide-details": "",
        "single-line": ""
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode($setup["CreateBillDialog"], {
            onBillCreated: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('refresh')))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        headers: $setup.headers,
        items: $props.bills,
        search: $setup.search
      }, {
        "item.status": _withCtx(({ value }) => [
          _createVNode(_component_v_chip, {
            color: $setup.statusColor(value),
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.statusLabel(value)), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        "item.type": _withCtx(({ value }) => [
          _createVNode(_component_v_chip, {
            color: $setup.typeColor(value),
            size: "small",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.typeLabel(value)), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        "item.amount": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString($setup.formatAmount(value)), 1)
        ]),
        "item.bookingItems": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value?.length ?? 0) + " elem", 1)
        ]),
        "item.createdAt": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString($setup.formatDate(value)), 1)
        ]),
        "item.id": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: "blue",
            text: "Részletek",
            onClick: ($event: any) => ($setup.handleViewClick(item.id))
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["items", "search"])
    ]),
    _: 1
  }))
}